import styled from 'styled-components';
import {
  color,
  container,
  fontSize,
  fontWeight,
  screen,
  spacing
} from '../../../theme';
import { Heading3 } from '../../shared/Typography';

export const StyledRequirementsResponsabilitiesContainer = styled.div`
  max-width: ${container('md')};

  margin-left: auto;
  margin-right: auto;
`;

export const StyledRequirementsResponsabilities = styled.div`
  margin-top: ${spacing('xl')};

  @media (min-width: ${screen('md')}) {
    margin-top: ${spacing('xl3')};
  }
`;

export const StyledRequirementsResponsabilitiesTitle = styled(Heading3)`
  && {
    margin-bottom: ${spacing('lg')};
    
    &::before {
      left: 0;
      transform: translateX(0);
    }
  }
`;

export const StyledRequirementsResponsabilitiesItem = styled.li`
  margin-bottom: ${spacing('md')};
  display: flex;
  font-weight: ${fontWeight('medium')};
  line-height: 1.2;

  p {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }

  @media (min-width: ${screen('lg')}) {
    font-size: ${fontSize('lg')};
  }

  svg {
    width: 1.25rem !important;
    height: 1.25rem;
    margin-right: ${spacing('sm')};
    color: ${color('midnight_300')};
    flex: 0 0 auto;

    @media (min-width: ${screen('lg')}) {
      width: ${spacing('lg')} !important;
      height: ${spacing('lg')};
    }
  }
`;
